/* eslint-disable import/prefer-default-export */

export const GET_MERCHANTS_STATS = "GET_MERCHANTS_STATS";
export const GET_DRIVERS_STATS = "GET_DRIVERS_STATS";
export const GET_MERCHANTS_STATS_ERROR = "GET_MERCHANTS_STATS_ERROR";
export const GET_DRIVERS_STATS_ERROR = "GET_DRIVERS_STATS_ERROR";
